/**
 * 환경 변수를 안전하게 가져오는 유틸리티 함수
 * 
 * @param key 가져올 환경 변수 키
 * @param defaultValue 환경 변수가 없을 경우 반환할 기본값
 * @returns 환경 변수 값 또는 기본값
 */ export var getEnvValue = function(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    // process.env 접근 시도
    if (typeof process !== 'undefined' && process.env && key in process.env) {
        return process.env[key] || defaultValue;
    }
    // window.env 접근 시도 (런타임 환경 변수)
    if (typeof window !== 'undefined' && window.env && key in window.env) {
        return window.env[key] || defaultValue;
    }
    // 환경 변수를 찾을 수 없으면 기본값 반환
    return defaultValue;
};
export default getEnvValue;
